import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { useStyles } from './styles';

export default function ResearchersAcademics({ bgColor, textTitle, variantTitle }) {
  const classes = useStyles();

  return (
    <Box py={6} bgcolor={bgColor || '#F1F1F1'}>
      <Container>
        <Typography
          className={classes.textContent}
          variant={variantTitle || 'h6'}
          component="h2"
          align="center"
        >
          {textTitle || (
            <b>
              {' '}
              Mind the Graph's trusted by researchers and academics from <br /> 100+ top academic,
              educational and industrial institutions as <br /> the best infographic maker and
              overall full-stack design tool{' '}
            </b>
          )}
        </Typography>

        <Box className={classes.logoWrapper}>
          <img src="/images/stanford-logo.png" loading="lazy" alt="Stanford logo" />
          <img src="/images/ucla-logo.png" loading="lazy" alt="UCLA logo" />
          <img src="/images/pearson-logo.png" loading="lazy" alt="Pearson logo" />
          <img src="/images/harvard-logo.png" loading="lazy" alt="Harvard logo" />
          <img src="/images/abbott-logo.png" loading="lazy" alt="Abbott logo" />
          <img src="/images/mcgill-logo.png" loading="lazy" alt="Mcgill logo" />
        </Box>
      </Container>
    </Box>
  );
}
